import apiClient from './api';

export interface SystemAlert {
  id: number;
  tenant_id: number | null;
  tenant_name: string | null;
  alert_type: string;
  severity: string;
  subject: string;
  details: Record<string, any>;
  related_id: number;
  related_entity: string;
  status: string;
  created_at: string;
  resolved_at: string | null;
}

export interface SystemHealth {
  queues: {
    jobs: { pending: number; running: number };
    optimization: { pending: number; running: number };
    autopilots: { overdue: number };
  };
  open_alert_count: number;
  last_watchdog_at: string | null;
  l5_crawl_storage: { count: number; bytes: number };
}

export interface ActivityItem {
  type: string;
  id: number;
  tenant_id: number;
  project_id: number;
  status: string;
  timestamp: string;
}

export const opsApi = {
  getAlerts: (params?: { status?: string; severity?: string }) =>
    apiClient.get<SystemAlert[]>('/admin/ops/alerts', { params }),
  updateAlert: (id: number, data: { status: string }) =>
    apiClient.patch(`/admin/ops/alerts/${id}`, data),
  retryAlert: (id: number) =>
    apiClient.post(`/admin/ops/alerts/${id}/retry`),
  getHealth: () =>
    apiClient.get<SystemHealth>('/admin/ops/health'),
  getActivity: () =>
    apiClient.get<ActivityItem[]>('/admin/ops/activity'),
};
